const menuMailing = `
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14">
      <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
        <g stroke="#F5F5F5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M17.625,10.5 C17.625,11.121 17.121,11.625 16.5,11.625 L1.5,11.625 C0.879,11.625 0.375,11.121 0.375,10.5 L0.375,1.5 C0.375,0.87825 0.879,0.375 1.5,0.375 L16.5,0.375 C17.121,0.375 17.625,0.87825 17.625,1.5 L17.625,10.5 Z"/>
          <polyline points="15.375 3.375 9 7.5 2.625 3.375"/>
          <path d="M2.625 9L5.25 7.5M15.375 9L12.75 7.5"/>
        </g>
        <rect width="18" height="12"/>
      </g>
    </svg>

`;

export default menuMailing;
